import { render, staticRenderFns } from "./PruebaImg.vue?vue&type=template&id=249b1716&scoped=true"
import script from "./PruebaImg.vue?vue&type=script&lang=js"
export * from "./PruebaImg.vue?vue&type=script&lang=js"
import style0 from "./PruebaImg.vue?vue&type=style&index=0&id=249b1716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249b1716",
  null
  
)

export default component.exports